<template>
  <div class="HomePage">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(ele, n) in msg" :key="n"
        ><div class="swiper-container">
          <page
            :header="ele.header"
            :tfl="ele.tfl"
            :content="ele.content"
            :title="ele.title"
            :index="'0' + (n + 1)"
            :url="ele.url"
          >
          </page></div
      ></swiper-slide>
    </swiper>
    <div class="custom-pagination"></div>
  </div>
</template>
<script>
import Page from "@/components/index/page.vue";
import { swiperAnimate, swiperAnimateCache } from "@/utils/animate.js";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Swiper,
    SwiperSlide,
    Page,
  },
  data() {
    return {
      msg: [
        {
          title: "华科融资租赁有限公司",
          content:
            "华科融资租赁有限公司2013年6月在重庆高新区注册成立，注册资本8亿元人民币，是一家外商投资、民营主导、国有参股、员工持股的混合所有制企业，系国内首家定位于服务科技创新和新经济、以“科技融资租赁”为主要手段的全国性综合金融服务公司，被工信部列为国家重点研发计划高新技术成果产业化试点单位。",
          url: "/aboutHK",
          header: {
            zy: "华科",
            zw: "租赁",
            ey: "CTFL ",
            ew: "INTRODUCTION",
          },
          tfl: {
            zr: "华科",
            zb: "租赁",
            er: "O",
            eb: "FFICIAL WEBSITE",
            del1: "服务科技创新",
            del2: "改变传统金融",
          },
        },
         // 基金公司
         {
          title: "华科产融企业服务（重庆）有限公司",
          content:
            "2017年6月成立，注册资本5,000万元，坚持“服务科技、服务创新”宗旨，致力于“租投联动、股债协同”，深耕川渝，辐射西南，主要服务新材料、新能源、节能环保、电子信息等行业客户，为科技型、创新型企业提供多元化综合金融服务。",
          url: "/fundcompany",
          header: {
            zy: "华科",
            zw: "产融",
            ey: "",
            ew: "INTRODUCTION",
          },
          tfl: {
            zr: "华科",
            zb: "产融",
            er: "F",
            eb: "UND COMPANIES",
            del1: "服务科技",
            del2: "服务创新",
          },
        },
        // 新数软
        {
          title: "重庆新数软信息科技有限公司",
          content:
            "2015年2月成立注册资本1,250万元，位于内陆第一个国家级开发新区——重庆两江新区。 专注于金融科技、产业数智化改造、数字孪生可视化服务。积极融合人工智能、大数据、云计算、物联网以及3d渲染技术。 积累了深厚的技术沉淀，多项技术已处于国内领先水平。通过多年探索与发展，我们获得了多项科技成果， 面向仓库、化工、能源、政府、汽车、各类园区等多个行业向客户提供多项解决方案。",
          url: "https://datadst.com/",
          header: {
            zy: "新数软",
            zw: "",
            ey: "",
            ew: "INTRODUCTION",
          },
          tfl: {
            zr: "新数软",
            zb: "",
            er: "O",
            eb: "FFICIAL WEBSITE",
            del1: "专注企业数字化服务",
            del2: "科技金融服务",
          },
        },
        // 懂车商
        {
          title: "重庆懂车商数字科技有限公司",
          content:
            "2018年8月成立，注册资本1,000万元，立足汽车流通行业，专注服务B端客户，持续赋能车商转型发展，提供资金和交易流通多维服务。通过重塑和改造汽车流通领域的各条垂直产业链和价值链，构建行业领先的新型汽车流通产业数字化平台。",
          url: "https://dongcs.com",
          header: {
            zy: "懂车商",
            zw: "",
            ey: "",
            ew: "INTRODUCTION",
          },
          tfl: {
            zr: "懂车商",
            zb: "",
            er: "O",
            eb: "FFICIAL WEBSITE",
            del1: "让二手车生意变简单",
            del2: "",
          },
        },
        
       
      ],
      swiperOptions: {
        pagination: {
          el: ".custom-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            let nameList = ["华科金融", "华科产融", "新数软", "懂车商" ];
            return (
              '<div class="' +
              className +
              '"><div class="pageName">' +
              nameList[index] +
              '</div><div class="paginayion_line"></div></div>'
            );
          },
        },
        direction: "horizontal",
        autoplay: {
          delay: 5000,
        },
        parallax: true,
        // 环路
        loop: false,
        effect: "fade",
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 100,
          shadowScale: 0.7,
        },
        on: {
          init: function () {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function () {},
          slideChangeTransitionEnd: function () {},
          slideChange: function () {
            swiperAnimate(this);
          },
        },
      },
    };
  },
};
</script>

<style scoped lang="scss">
.HomePage {
  width: 100%;
  height: 100%;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.custom-pagination {
  width: 584px;
  position: absolute;
  left: 1040px;
  z-index: 20;
  bottom: 110px;
}

:deep(.swiper-pagination-bullet) {
  width: 132px;
  height: 50px;
  background-color: transparent;
  border-radius: 2px 2px 2px 2px;
  margin: 0 7px;
  color: #1c1c1c;
  cursor: pointer;
  overflow: hidden;
  .pageName {
    width: 132px;
    height: 40px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-size: 18px;
    text-align: left;
    margin-bottom: 6px;
  }
  .paginayion_line{
    width: 132px;
    height: 4px;
    background: #1c1c1c;
  }
}
:deep(.swiper-pagination-bullet-active) {
  color: #bd2b2b;
  .paginayion_line{
  background-color: #bd2b2b;
  }

}
</style>